import React, { useState, useEffect } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import manufacturingIcon from "../../../../../assets/new-product-detail-cats/header-icons/manufacturing-icon.svg";
import { useTranslation } from "react-i18next";
import formatDate from "../../components/HeaderBox/formatDate";
import { getCustomManufacturing34Totals } from "../../../../../apis/Product/CustomManufacturingFlow34Api";

const CustomManufacturingIcon = () => (
  <img src={manufacturingIcon} alt="Custom Manufacturing Icon" width={76} height={76} />
);

const CustomManufacturingHeader = ({
  className,
  leftBoxProps,
  rightBoxProps,
  productId,
  show,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalCustomManufacturingItem, setTotalCustomManufacturingItem] = useState(null);

  useEffect(() => {
    if (productId) {
      getCustomManufacturing34Totals({
        productId,
        setTotals: setTotalCustomManufacturingItem,
      });
    }
  }, [productId]);

  return (
    <CategoryComponent
      show={show}
      className={`custom-manufacturing-category ${className || ""}`}
      leftBoxProps={{
        icon: <CustomManufacturingIcon />,
        title: t("CUSTOM_MANUFACTURING") || "Custom Manufacturing",
        description:
          t("CUSTOM_MANUFACTURING_DESC") ||
          "Custom manufacturing processes and inputs",
        productId: productId,
        isSystemBoundary: false,
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_LIFECYCLE_PHASE"),
            items: [
              {
                subtitle: "",
                subitems: [],
              },
            ],
            isSwitchable: true,
          },
          // {
          //   title: t("TOTAL_FOR_FLOW_34") || "Total for Flow 34",
          //   items: [
          //     {
          //       subtitle: "",
          //       subitems: [],
          //     },
          //   ],
          //   isSwitchable: true,
          // },
        ],
        impactTotals: totalCustomManufacturingItem?.impact_totals || null,
        lastUpdated: totalCustomManufacturingItem?.updated_at
          ? formatDate(totalCustomManufacturingItem?.updated_at)
          : t("DD_MM_YYYY"),
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default CustomManufacturingHeader;
